import styled from "styled-components";

import { NumberInputStyledProps as Props } from "./NumberInput.types";

const NumberInputStyled = styled.div<Props>`
  position: relative;

  &&& .TextInput__input {
    text-align: right;
  }

  .NumberInput {
    &__symbol {
      position: absolute;
      bottom: 1.2rem;
      left: 1.6rem;
      z-index: 2;
      font-size: 1.6rem;
      font-weight: 600;
      line-height: 3rem;
    }
  }
`;

export default NumberInputStyled;
